import React, { ReactElement } from "react";
import { redirect, Route } from "react-router-dom";

type ProtectedRouteProps = {
  children: ReactElement;
};

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isLoggedIn =
    localStorage.getItem("userAuthorized") !== null &&
    localStorage.getItem("userAuthorized") === "true";
  return !isLoggedIn ? (
    <div className="text-center text-2xl flex justify-center">
      <div className="bg-gray-400">
        You are not signed in. Please log in to the system.
      </div>
    </div>
  ) : (
    children
  );
};

export default ProtectedRoute;
